import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { protectedResources } from '../auth-config';

type ProfileType = {
  name?: string
};

@Component({
    selector: 'app-webapi',
    templateUrl: './webapi.component.html',
    styleUrls: ['./webapi.component.css'],
    standalone: false
})
export class WebapiComponent implements OnInit {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;
  profile!: any;

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.http.get(this.brennerSoftwareApiEndpoint)
      .subscribe(profile => {
        this.profile = profile;
      });
  }
}
